<template>
  <page-wrapper background="/static/img/anniversary/page-start/bg.png">
    <img class="main-title ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-start/shape-1-new.png" />
    <img class="main-button ani" @click="handleButtonClick" swiper-animate-effect="animate__pulse" src="/static/img/anniversary/page-start/shape-02.png" />
    <img class="brand-area ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-start/shape-3-new.png" />
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'

export default {
  components: { PageWrapper },
  methods: {
    handleButtonClick () {
      this.swiper.slideNext()
    }
  },
  props: [
    'swiper'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .main-title {
    position: absolute;
    //width: 84.8vw;
    //height: 80.8vw;
    left: 50%;
    margin-left: -50vw;
    top: 31.06vw;
  }

  .main-button {
    width: 73.86vw;
    height: 17.86vw;
    position: absolute;
    left: 50%;
    margin-left: -36.93vw;
    bottom: 36vw;
  }

  .brand-area {
    position: absolute;
    left: 50%;
    margin-left: -44px;
    top: 12.8vw;
    width: 23vw;
    height: 13vw;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?73cda936